import { createColumnHelper } from '@tanstack/react-table';

import { Tag } from '../types';

export const helper = createColumnHelper<Tag>();
